import _ from 'lodash';
import React from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import classNames from 'classnames';

import { Loading } from 'components/loading';

const shouldShowBackdrop = (backdrop) => (_.isUndefined(backdrop) ? true : !!backdrop);
const render = (child, params) => (_.isFunction(child) ? child(params) : child);

export const Drawer = ({
  disableCloseOnClickOutside, className, onClose, handleClick, title, children, placement, show, loading, backdrop,
}) => {
  const onHide = onClose || handleClick;
  const ref = React.useRef();
  const showBackdrop = shouldShowBackdrop(backdrop);
  const drawerClass = classNames(
    className,
    'rax-drawer',
    'shadow-lg',
  );

  return (
    <Offcanvas ref={ref} placement={placement || 'end'} backdrop={showBackdrop} className={drawerClass} show={show} onEscapeKeyDown={onHide}>
      <Offcanvas.Header closeButton onHide={onHide} className="sticky-top border-bottom z-1">
        <Offcanvas.Title as="h2">
          {render(title, { show })}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {loading ? (<Loading centered />) : (
          render(children, { show })
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Drawer;
